module.exports = __webpack_public_path__ + "static/media/70001.a7382498.png";